module.exports = __webpack_public_path__ + "static/media/connectButton.9c0dbe63.svg";